import React, { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'https://kinos-api.onrender.com';
const APP_SIGNUP_URL = 'https://engagement.kolanut.ai/signup';

const emailOk = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim().toLowerCase());

const GotQuestionsSection = ({ onBookDemo }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!emailOk(email)) {
      setErrorMessage('Please enter a valid work email.');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch(`${API_BASE}/api/kolanut-landing/early-access`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setStatus('error');
        setErrorMessage(data.message || 'Something went wrong. Please try again.');
        return;
      }

      const next = new URL(APP_SIGNUP_URL);
      next.searchParams.set('email', email.trim());
      window.location.assign(next.toString());
    } catch {
      setStatus('error');
      setErrorMessage('Network error. Check your connection and try again.');
    }
  };

  const handleBookDemo = () => {
    fetch(`${API_BASE}/api/kolanut-landing/demo-click`, { method: 'POST' }).catch(() => {});
    onBookDemo?.();
  };

  return (
    <section
      id="early-access"
      className="border-t border-[#c4ffa0]/25 bg-gradient-to-b from-[#f4fbf4] to-white py-16 md:py-28"
    >
      <div className="max-w-2xl mx-auto px-6 text-center">
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-black/80 mb-6">
          Early access
        </p>

        <h2 className="text-2xl sm:text-3xl md:text-[2.125rem] font-semibold text-black tracking-tight leading-snug mb-4">
          <span className="block">Your business is already generating the data.</span>
          <span className="mt-2 block text-xl sm:text-2xl md:text-[1.75rem] font-medium text-black/85">
            Let Kolanut turn it into growth.
          </span>
        </h2>

        <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-12 max-w-xl mx-auto">
          Free for the first 200 businesses · No card · ~2 min setup
        </p>

        <form onSubmit={handleSubmit} className="space-y-3 max-w-xl mx-auto" noValidate>
          <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-stretch sm:justify-center sm:gap-2">
            <label htmlFor="early-access-email" className="sr-only">
              Work email
            </label>
            <input
              id="early-access-email"
              name="email"
              type="email"
              autoComplete="email"
              inputMode="email"
              placeholder="you@company.com"
              value={email}
              disabled={status === 'loading'}
              onChange={(e) => {
                setEmail(e.target.value);
                if (status === 'error') setStatus('idle');
              }}
              className="w-full min-h-[52px] min-w-0 sm:flex-1 sm:min-w-[12rem] rounded-full border border-gray-200 bg-white px-6 py-3.5 text-base text-gray-800 placeholder:text-gray-400 shadow-sm outline-none transition focus:border-[#8ae690] focus:ring-2 focus:ring-[#c4ffa0]/35 disabled:opacity-50"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="min-h-[52px] shrink-0 rounded-full bg-[#8ae690] px-10 text-base font-semibold text-black shadow-sm transition hover:bg-[#7ad67f] disabled:opacity-50"
            >
              {status === 'loading' ? 'Sending…' : 'Continue'}
            </button>
            {onBookDemo ? (
              <button
                type="button"
                onClick={handleBookDemo}
                className="min-h-[52px] shrink-0 rounded-full border border-black/35 bg-transparent px-8 text-base font-semibold text-black transition hover:bg-black/5"
              >
                Book demo
              </button>
            ) : null}
          </div>

          {errorMessage ? (
            <p className="text-left text-sm text-red-600" role="alert">
              {errorMessage}
            </p>
          ) : null}

          <p className="pt-1 text-sm text-gray-500">No spam. Unsubscribe anytime.</p>
        </form>
      </div>
    </section>
  );
};

export default GotQuestionsSection;
